import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No. El contenido está organizado para principiantes y avanza paso a paso desde los conceptos fundamentales, incluso si nunca has vendido por internet.'
}, {
  question: '¿Cuándo recibo el acceso?',
  answer: 'El acceso es inmediato después de completar el pago. Recibirás de forma digital toda la información necesaria para comenzar el mismo día.'
}, {
  question: '¿El acceso es para siempre?',
  answer: 'Sí. Tu acceso es de por vida, sin pagos mensuales, e incluye las actualizaciones futuras disponibles para el programa.'
}, {
  question: '¿Puedo aprender a mi ritmo?',
  answer: 'Sí. Puedes avanzar cuando quieras y repetir cualquier módulo, desde computadora, tablet o celular, según te resulte más cómodo.'
}, {
  question: '¿Qué incluye exactamente mi compra?',
  answer: 'Incluye el programa principal Amazon Master System™ con Amazon FBA y Amazon FBM explicados paso a paso, más la biblioteca premium con 6 recursos profesionales: listas de productos, plantillas, checklists y guías de proveedores, envíos y campañas.'
}];
export function PreguntasFrecuentes() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-white px-5 py-20 sm:px-6 md:py-28" data-id="element-538" data-mp="30pmlpe555lfa">
      <div className="mx-auto max-w-3xl" data-id="element-539" data-mp="30ns52c0wkfh0">
        <FadeIn data-id="element-540" data-mp="2wp2sumrlp3yy">
          <div className="mb-12 text-center md:mb-14" data-id="element-541" data-mp="2wnhwqspn1cyz">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-542" data-mp="3afoa671ep5uq">
              Resolvemos tus dudas
            </p>
            <h2 className="font-serif text-3xl font-bold tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-543" data-mp="35hw8ilaym5dc">
              Preguntas frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="divide-y divide-brand-text/10 rounded-2xl border border-brand-text/10 bg-white" data-id="element-544" data-mp="3fg298zl155gm">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={faq.question} delay={0.04 * index} data-id="element-545" data-mp="3rhbqydtu32z6" data-mpi={index}>
                <div data-id="element-546" data-mp="ah9x6iqhnwg">
                  <button type="button" onClick={() => setOpenIndex(current => current === index ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left sm:px-7 sm:py-6" data-id="element-547" data-mp="969ngohyya3">
                    <span className="text-base font-bold text-brand-green sm:text-lg" data-id="element-548" data-mp="iz5x5z4ow5be">
                      {faq.question}
                    </span>
                    <ChevronDown className={`h-5 w-5 flex-shrink-0 text-brand-gold transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-549" data-mp="2ktn9duff5p2c" />
                  </button>
                  {isOpen && <div className="px-6 pb-6 sm:px-7 sm:pb-7" data-id="element-550" data-mp="2ia0e0cukfan5">
                      <p className="max-w-2xl text-sm leading-relaxed text-brand-text/70 sm:text-base" data-id="element-551" data-mp="2dgp5m7a3ult4">
                        {faq.answer}
                      </p>
                    </div>}
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}